module.exports = __webpack_public_path__ + "static/img/logo-triangle.3a617a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-triangle.png
// module id = ZOmJ
// module chunks = 0